import React from "react";
import { CircularProgress } from "@mui/material";

const Spinner = () => <CircularProgress size={30} />;
export default Spinner;
